export default "__VITE_ASSET__CGipOZl___"